import { Component, NgModule, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DynamicControlErrorModule } from './dynamic/dynamic-control-error.component';
import { BaseComponent } from '../../../models/base/base.component';

import { InputTextModule } from 'primeng/inputtext';

import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { LastUpdatedModule } from './last-updated.component';
import { LoadingModule } from './loading.component';
import { DynamicValueModule } from './dynamic/dynamic-value.component';
import { LookupService } from '../../../services/lookup.service';



@Component({
  selector: 'vehicles-detail',
  templateUrl: './vehicles-detail.component.html',
  providers: [LookupService]
})
export class VehiclesDetailComponent extends BaseComponent implements OnInit {
  @Input() model: any[];
  @Input() showTitle: boolean = true;
  @Input() openEnclosed: any = null;

  lookups: any = {};

  constructor(private lookupService: LookupService) {
    super();
  }

  ngOnInit() {
    this.loadLookup('openEnclosed');
    this.loadLookup('operability');
  }


  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
        this.lookups[key] = r;
      });
  }
}


@NgModule({
  declarations: [
    VehiclesDetailComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    InputTextareaModule,
    ButtonModule,
    DynamicControlErrorModule,
    LastUpdatedModule,
    LoadingModule,
    DynamicValueModule,
  ],
  exports: [
    VehiclesDetailComponent
  ]
})
export class VehiclesDetailModule { }
